import { createSlice } from '@reduxjs/toolkit'
import { keyBy } from '../../../../helpers/common'
import { register } from '../../../../helpers/reducerRegistry'
import { TYPE_REPORTS, TYPE_REPORTS_SELECT } from '../constant'
import { getReports } from './thunk'

const initialState = {
  loading: {
    getReports: true,
  },
  dataReport: [],
  dataTableReport: {},
  idsTable: [],
  typeReport: TYPE_REPORTS_SELECT[TYPE_REPORTS.ALL_REPORTS],
  filterTable: {
    Term: '',
    StartDate: null,
    EndDate: null,
    Page: 1,
    PageSize: 20,
  },
  totalRecords: 0,
  heightItem: 0,
}

const slice = createSlice({
  name: 'dashboard/latestReports',
  initialState: initialState,
  reducers: {
    resetStore: () => initialState,
    changeTypeReport: (state, action) => {
      state.typeReport = action.payload
    },
    changeFilterTable: (state, action) => {
      state.filterTable = { ...state.filterTable, ...action.payload }
    },
    changeTotalRecords: (state, action) => {
      state.totalRecords = action.payload
    },
    changeHeightItem: (state, action) => {
      state.heightItem = action.payload
    },
  },
  extraReducers: (builder) => {
    //getReports
    builder.addCase(getReports.pending, (state) => {
      state.dataReport = []
      state.idsTable = []
      state.dataTableReport = {}
      state.loading.getReports = true
    })
    builder.addCase(getReports.fulfilled, (state, { payload = [] }) => {
      state.dataReport = payload
      state.idsTable = payload.map((item) => item?.reportId)
      state.dataTableReport = keyBy(payload, 'reportId')
      state.loading.getReports = false
    })
    builder.addCase(getReports.rejected, (state, action) => {
      state.idsTable = []
      state.loading.getReports = action.payload.loading
    })
  },
})

//loading
export const getLoadingReport = (type) => (state) =>
  state[slice.name].loading[type]
//type Report
export const selectTypeReport = (state) => state[slice.name].typeReport
//getReports
export const selectDataReport = (state) => state[slice.name].dataReport
//table idsTable
export const getDataFromReduxTableReports = (rowId, colId) => (state) =>
  state[slice.name].dataTableReport[rowId][colId]

export const selectDataTableReports = (rowId) => (state) =>
  state[slice.name].dataTableReport[rowId]

export const getFilterTable = (type) => (state) =>
  type ? state[slice.name].filterTable[type] : state[slice.name].filterTable

export const selectTotalRecords = (state) => state[slice.name].totalRecords

export const selectIdsTable = (state) => state[slice.name].idsTable

export const selectHeightItemReport = (state) => state[slice.name].heightItem

export const {
  resetStore,
  changeTypeReport,
  changeFilterTable,
  changeTotalRecords,
  changeHeightItem,
} = slice.actions

register(slice.name, slice.reducer)
